export default class FullwidthSection {

    constructor() {

        if(this.fullWidthSections = document.querySelectorAll(".full-width-section")) {
            this._detectScrollbarWidth()
        }
    }

    _detectScrollbarWidth() {
        // this technique for detecting the scrollbar width is from:
        // https://davidwalsh.name/detect-scrollbar-width

        // Create the measurement node
        const scrollDiv = document.createElement("div");
        scrollDiv.className = "scrollbar-measure";
        document.body.appendChild(scrollDiv);

        // Get the scrollbar width
        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        // Delete the DIV
        document.body.removeChild(scrollDiv);

        // loop through the full width elements - then apply the width and margin-left
        for(let i = 0, l = this.fullWidthSections.length; i < l; i += 1) {
            this.fullWidthSections[i].style.width = `calc(100vw - ${scrollbarWidth}px)`
            this.fullWidthSections[i].style.marginLeft = `calc(-50vw + ${Math.floor(scrollbarWidth/2)}px)`
        }
    }
}